<template>
    <div class="photo-joystick abs b-1 l-1 depth-4"
         :class="{ 'b-15': shouldConsideGPR }">
        <div class="f space-x-0.75">
            <!-- Controls -->
            <plan-button-group v-if="shouldDisplayControls">
                <plan-button :disabled="!hasPrevImage"
                             el-icon="el-icon-arrow-left text-white"
                             :class="{ 'is-disabled': !hasPrevImage }"
                             @click="doPrev" />
                <plan-button :disabled="!hasNextImage"
                             el-icon="el-icon-arrow-right text-white"
                             :class="{ 'is-disabled': !hasNextImage }"
                             @click="doNext" />
            </plan-button-group>

            <!-- Warnings (DISABLED) -->
            <plan-button v-if="false && hasWarnings"
                         :tooltip="labels.aboutOrientation"
                         color="red-1"
                         icon="warning">
                <template #tooltip>
                    <ul class="_px-1 _py-0.25 _m-0 space-y-0.25">
                        <li v-if="!hasPhotoOrientation">
                            {{ labels.aboutOrientation }}
                        </li>
                        <li v-if="!hasPlanNorth">
                            {{ labels.aboutNorth }}
                        </li>
                        <li v-if="!hasPlanDelta">
                            {{ labels.aboutDelta }}
                        </li>
                    </ul>
                </template>
            </plan-button>

            <div class="f-y-end space-x-0.25">
                <!-- Description --> 
                <plan-button :active="shouldDisplayDescription"
                             class="max-h-2"
                             el-icon="el-icon-info text-white"
                             @click="handleChangeDisplayDescription" />
    
                <div v-if="shouldDisplayDescription"
                     class="bg-rock text-white f-y-center font-medium lh-1 fs-0.75 _p-0.5 rounded">
                    {{ descriptionShort }}
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import { resourceable } from '@/store/connectors'

import {imagePathShortWithDatesFilter, imagePathShortWithDatesFilterShort } from '@/filters/photo'

import PlanButtonGroup from '@/components/map/PlanButton/PlanButtonGroup'
import PlanButton from '@/components/map/PlanButton/PlanButton'

export default {
  components: {
    PlanButton,
    PlanButtonGroup
  },
  mixins: [
    resourceable({ on: 'projects', name: 'projectOptions' })
  ],
  props: {
    point: { type: Object, default: null },

    shouldDisplayControls: Boolean,
    shouldConsideGPR: Boolean,
    hasPrevImage: Boolean,
    hasNextImage: Boolean,

    hasPhotoOrientation: Boolean,
    hasPlanNorth: Boolean,
    hasPlanDelta: Boolean
  },
  data() {
    return {
      shouldDisplayShortDescription: false,
      shouldDisplayDescription: false
    }
  },
  computed: {
    labels() {
      return {
        aboutOrientation: 'Фотография не имеет данных ориентации в пространстве',
        aboutNorth: 'На плане не указано направление на север',
        aboutDelta: 'На плане не указан масштаб'
      }
    },

    hasWarnings() {
      return !this.hasPhotoOrientation || !this.hasPlanNorth || !this.hasPlanDelta
    },

    description() {
      return imagePathShortWithDatesFilter(this.point)
    },

    descriptionShort() {
      return imagePathShortWithDatesFilterShort(this.point)
    }
  },
  watch: {
    projectOptions: {
      handler({ always_show_defining_point_image_shot_at: value } = {}) {
        this.shouldDisplayDescription = value
      },
      immediate: true
    }
  },
  mounted() {
    this.fetchProjectOptions()
      .then(({ always_show_defining_point_image_shot_at: x }) => this.shouldDisplayShortDescription = !!x)
  },
  methods: {
    doPrev() { this.$emit('on-prev') },
    doNext() { this.$emit('on-next') },

    handleChangeDisplayDescription() {
      this.shouldDisplayDescription = !this.shouldDisplayDescription
    }
  }
}
</script>

<style lang="scss">
.photo-joystick {
  .el-button {
    display: inline-flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    border-top: none;
    border-bottom: none;

    &-group {
      display: inline-flex;

      .el-button {
        height: auto;
      }
    }

    &:hover {
      background: #409eff !important;
      border-color: #409eff !important;
    }

    &.is-active {
      background: #409eff !important;
      border-color: #409eff !important;
    }

    &.is-disabled {
      background-color: #2C2C2C !important;
      border-color: #2C2C2C !important;
      color: #616161 !important;
    }
  }
}
</style>
